import { render, staticRenderFns } from "./chemUpdateHistoryMailUsers.vue?vue&type=template&id=effa828a"
import script from "./chemUpdateHistoryMailUsers.vue?vue&type=script&lang=js"
export * from "./chemUpdateHistoryMailUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('effa828a')) {
      api.createRecord('effa828a', component.options)
    } else {
      api.reload('effa828a', component.options)
    }
    module.hot.accept("./chemUpdateHistoryMailUsers.vue?vue&type=template&id=effa828a", function () {
      api.rerender('effa828a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/form/chemUpdateHistoryMailUsers.vue"
export default component.exports